import { render, staticRenderFns } from "./LegoInstance.vue?vue&type=template&id=5dc12ccd&scoped=true&"
import script from "./LegoInstance.vue?vue&type=script&lang=ts&"
export * from "./LegoInstance.vue?vue&type=script&lang=ts&"
import style0 from "./LegoInstance.vue?vue&type=style&index=0&id=5dc12ccd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc12ccd",
  null
  
)

export default component.exports